import moment from "moment-timezone";

// this helper function will take a time and a timezone and return the time in the format "DD-MM-YYYY HH:mm z"
export const formatTimeByTimezone = (time, timezone) => {
  return moment(time).tz(timezone).format("YYYY-MM-DD HH:mm z");
};
